module.exports = __webpack_public_path__ + "static/media/industria-6.d99e96bb.jpg";